// extracted by mini-css-extract-plugin
export default {"dialog":"InfoDialog_dialog__QVjmR","description":"InfoDialog_description__98NNq"};